import React, { useMemo } from 'react';
import SpinnerCircular from 'sushiweb/Spinner/SpinnerCircular';
import { grey } from 'sushiweb/tokens/color';
import './loader.scss';

export const Loader = ({
  size = 'large',
  color = `${grey.z500}`,
  fullHeight = false,
}) => {
  const height = useMemo(() => {
    if (fullHeight) return 'calc(100vh - 7rem)';
    return 'auto';
  }, [fullHeight]);

  return (
    <div className='loader' style={{ height: height }}>
      <SpinnerCircular size={size} color={color} />
    </div>
  );
};
